import { createRouter } from '@modules/router'
import { getUserLanguage } from '@modules/browser'
export default createRouter([
  {
    path: '*',
    name: 'nopage',
    component: () => import(/* webpackChunkName: "no-page-view" */ '@views//NoPageView.vue')
  },
  {
    path: '/',
    name: 'index',
    redirect: `/${getUserLanguage()}/home`
  },
  {
    name: 'language',
    path: '/:language',
    component: () => import(/* webpackChunkName: "locale-view" */ '@views/LocaleView.vue'),
    redirect: {
      name: 'home'
    },
    children: [
      {
        name: 'home',
        component: () => import(/* webpackChunkName: "home-view" */ '@views/HomeView.vue'),
        path: 'home'
      },
      {
        name: 'biography',
        component: () => import(/* webpackChunkName: "biography-view" */ '@views/BiographyView.vue'),
        path: 'biography'
      },
      {
        name: 'bibliography',
        component: () => import(/* webpackChunkName: "bibliography-view" */ '@views/BibliographyView.vue'),
        path: 'bibliography'
      },
      {
        name: 'prices',
        component: () => import(/* webpackChunkName: "prices-view" */ '@views/PricesView.vue'),
        path: 'prices'
      },
      {
        name: 'works',
        component: () => import(/* webpackChunkName: "works-view" */ '@views/WorksView.vue'),
        path: 'works'
      },
      {
        name: 'project',
        component: () => import(/* webpackChunkName: "work-view" */ '@views/WorkView.vue'),
        path: 'works/:projectId',
        props: true
      },
      {
        name: 'about',
        component: () => import(/* webpackChunkName: "about-view" */ '@views/AboutView.vue'),
        path: 'about'
      }
    ]
  }
])
